import {
  Box,
  Breakpoint,
  Button,
  Image,
  Text,
  useBreakpoint,
} from '@bonanza-social/moonlight';
import { memo } from 'react';
import { PendingRewardCardProps } from './PendingRewardCard.types';

function PendingRewardCard({
  itemWidth,
  pendingReward,
}: PendingRewardCardProps) {
  const breakpoint = useBreakpoint();
  const { imageName, onPress, rewardText, ctaLocKey } = pendingReward;

  return (
    <Box
      testID={`pending-reward-card-${pendingReward.ctaLocKey}`}
      padding="space-025"
      width={
        breakpoint === Breakpoint.MOBILE || !itemWidth ? '100%' : itemWidth
      }
    >
      <Box
        backgroundColor="primaryBackground"
        borderRadius="radius-200"
        borderColor="borderWashed"
        borderWidth="border-width-025"
        padding="space-400"
        gap="space-400"
        flexDirection="row"
      >
        <Image name={imageName} width={72} height={72} />
        <Box gap="space-400" flex={1}>
          <Text variant="body-m-semi" color="darkSurfacePrimary">
            {rewardText}
          </Text>
          <Button
            width="100%"
            locNS="rewards"
            locKey={ctaLocKey}
            onPress={onPress}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(PendingRewardCard);
